import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Modal from '@mui/material/Modal';
import style from '../Tools/Style';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, Typography, Grid } from '@mui/material';
import TUsuarios from '../Seguridad/TUsuarios';

function rand() {
  return Math.round(1 * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: '80%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0,
  },
}));

export default function ModalUsuarios({
  open,
  handleClose,
  data,
  seleccionarUsuario,
  datosCargados,
}) {
  const classes = useStyles();

  const [modalStyle] = React.useState(getModalStyle);

  const [termp, setTermp] = useState('');

  const handleCloseModal = () => {
    handleClose();
    setTermp('');
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <Typography
        id="simple-modal-title"
        component="h3"
        variant="h4"
        color="primary"
      >
        Buscar Usuarios
      </Typography>

      <SearchIcon style={style.iconbuscar} />
      <TextField
        name="term"
        style={style.TextFieldbuscar}
        onChange={(e) => setTermp(e.target.value)}
        label="Buscar"
      />
      <div notranslate="true">
        {datosCargados ? (
          <TUsuarios
            rows={data}
            seleccionar={seleccionarUsuario}
            termp={termp}
            setTermp={setTermp}
            isModal={true}
          />
        ) : (
          <Grid container justify="center">
            <CircularProgress />
            <br />
            <Typography>Cargando...</Typography>
          </Grid>
        )}
      </div>
    </div>
  );
  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </React.Fragment>
  );
}
